import React from 'react'
import { StateProvider } from '../stores/multipost'
import { Col, Row } from 'reactstrap'
import AccountSettings from './Multipost/AccountSettings'
import FileSelector from './Multipost/FileSelector'
import MultipostForm from './Multipost/MultipostForm'
import Messages from './Multipost/Messages'
import ScheduleSettings from './Multipost/ScheduleSettings'
import SubmitButton from './Multipost/SubmitButton'

export default function Multipost(props) {
  const title = props.share.id ? "Edit Social Media Post" : "New Social Media Post"

  return (
    <StateProvider {...props}>
      <h1 className="mb-3">{title}</h1>
      <MultipostForm action={props.formPath} method={props.share.id ? 'patch' : 'post'}>
        <Row className="multi-post">
          <Col xs="12" lg="4" className="order-0 order-lg-1">
            <AccountSettings />
          </Col>
          <Col xs="12" lg="8" className="order-1 order-lg-0">
            <FileSelector />
            <Messages />
            <ScheduleSettings />
            <SubmitButton />
          </Col>
        </Row>
      </MultipostForm>
    </StateProvider>
  )
}
